// Lib/creator-route.js - Updated debug fields
import { Navigate, useLocation } from "react-router-dom";
import routes from "../Config/routes";
import { useCreatorAuth } from "../Hooks/creator-use-auth";
import { CircularProgress, Box } from "@mui/material";
import { toast } from 'sonner';

export default function CreatorRoute({ children }) {
  const { isAuthorized, isInitialized, creatorToken, token } = useCreatorAuth();
  const location = useLocation();

  // DEBUG: Log every render with correct field names
  if (process.env.NODE_ENV === 'development') {
    console.log('🔍 [CreatorRoute] Render:', {
      pathname: location.pathname,
      isAuthorized,
      isInitialized,
      hasJWTToken: !!token,           // JWT for auth
      hasUserInfo: !!creatorToken,    // User profile data
      timestamp: new Date().toISOString()
    });
  }

  if (!isInitialized) {
    if (process.env.NODE_ENV === 'development') {
      console.log('⏳ [CreatorRoute] Showing loading - not initialized');
    }
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthorized) {
    if (process.env.NODE_ENV === 'development') {
      console.log('🚫 [CreatorRoute] Not authorized - redirecting to login');
    }
    
    const searchParams = new URLSearchParams(location.search);
    if (location.pathname === routes.creatorConnectOauth) {
      searchParams.set("redirect", "oauth");
    }
    searchParams.set("tab", "creator");
    
    const loginUrl = `${routes.login}?${searchParams.toString()}`;
    if (process.env.NODE_ENV === 'development') {
      console.log('🚫 [CreatorRoute] Redirecting to:', loginUrl);
    }
    toast.info('Authentication required', {
      description: 'Redirecting to login page'
    });
    return <Navigate to={loginUrl} />;
  }

  if (process.env.NODE_ENV === 'development') {
    console.log('✅ [CreatorRoute] Authorized - rendering children');
  }
  return <>{children}</>;
}